import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import NaoSomosAgencia from "../components/site/NaoSomosAgencia";
import ComoOperamos from "../components/site/ComoOperamos";
import QuemNaoAtendemos from "../components/site/QuemNaoAtendemos";
import Posicionamento from "../components/site/Posicionamento";
import FAQ from "../components/site/FAQ";
import CTAFinal from "../components/site/CTAFinal";
import Footer from "../components/site/Footer";

export default function LandingPage() {
    return (
        <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="landing-page">
            <Header />
            <main>
                <Hero />
                <NaoSomosAgencia />
                <ComoOperamos />
                <QuemNaoAtendemos />
                <Posicionamento />
                <FAQ />
                <CTAFinal />
            </main>
            <Footer />
        </div>
    );
}
